import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SpinnerComponentComponent } from '../../modules/shared/components/spinner-component/spinner-component.component';
import { AwsAuthService } from '../../services/aws-auth.service';


@Component({
    selector: 'app-logout-handler',
    templateUrl: './logout-handler.component.html',
    styleUrls: ['./logout-handler.component.scss'],
    imports: [SpinnerComponentComponent],
    standalone: true
})
export class LogoutHandlerComponent implements OnInit {
  isProdEnvironment: boolean = true;

  constructor(private readonly _awsauthService: AwsAuthService,
    private readonly _router : Router) { }
  isCiamClicked: any;
  isCiamLinkingInProgress = false;


  ngOnInit(): void {
    this.isCiamClicked = sessionStorage.getItem('ciamClicked');
    this.handleDifferentIdLogin();
  }

  /**
   * @description This is triggered when the user is in /logout route
   Generally happens when we click on Connect with Other Mercedes Me ID link
   Handles navigation. If user clicks on Connect with Other Mercedes Me ID from any page
   and session storage has this variable set we navigate user to CIAM
   */
  public handleDifferentIdLogin(): void {
    this.isCiamLinkingInProgress = sessionStorage.getItem('partcipationDetails') ? true : false;
    // MBSTORIES-10196: AMAP CIAM Linking; mandate country selection.
    // Post country selection take user to right region and provider
    const isCountryOfOriginSelected = localStorage.getItem('countryOfOrigin');
    if (this.isCiamClicked || isCountryOfOriginSelected) {
      this._awsauthService.manageLoginResponse();
    } else {
      const language = localStorage.getItem('language') ?? 'en-GB';
      this._router.navigateByUrl('/' + language + '/home');
    }
  }

}
